/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActivityEvent } from './ActivityEvent';
import {
    ActivityEventFromJSON,
    ActivityEventFromJSONTyped,
    ActivityEventToJSON,
    ActivityEventToJSONTyped,
} from './ActivityEvent';

/**
 * Result of marking an individual event as read
 * @export
 * @interface MarkEventReadResponse
 */
export interface MarkEventReadResponse {
    /**
     * 
     * @type {boolean}
     * @memberof MarkEventReadResponse
     */
    success: boolean;
    /**
     * 
     * @type {ActivityEvent}
     * @memberof MarkEventReadResponse
     */
    event: ActivityEvent;
}

/**
 * Check if a given object implements the MarkEventReadResponse interface.
 */
export function instanceOfMarkEventReadResponse(value: object): value is MarkEventReadResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('event' in value) || value['event'] === undefined) return false;
    return true;
}

export function MarkEventReadResponseFromJSON(json: any): MarkEventReadResponse {
    return MarkEventReadResponseFromJSONTyped(json, false);
}

export function MarkEventReadResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkEventReadResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'event': ActivityEventFromJSON(json['event']),
    };
}

export function MarkEventReadResponseToJSON(json: any): MarkEventReadResponse {
    return MarkEventReadResponseToJSONTyped(json, false);
}

export function MarkEventReadResponseToJSONTyped(value?: MarkEventReadResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'event': ActivityEventToJSON(value['event']),
    };
}

